import { createSelector } from 'reselect';
import { IAppState, IReferenceData } from 'types';

const policyTypes = (state: IReferenceData) => state.policyTypes;

export const selectReferenceState = (state: IAppState) => state.referenceData;

export const selectEmployersRef = createSelector(
  selectReferenceState,
  (referenceData: IReferenceData) => referenceData.employers,
);

export const selectPolicyProvidersRef = createSelector(
  selectReferenceState,
  (referenceData: IReferenceData) => referenceData.policyProviders,
);

export const selectPolicyTypes = createSelector(
  selectReferenceState,
  policyTypes,
);

export const selectCreditCardsRef = createSelector(
  selectReferenceState,
  (reference: IReferenceData) => reference.creditCards,
);

export const selectEmployerById = createSelector(
  selectEmployersRef,
  (_, employerId: string) => employerId,
  (employers, employerId) => employers.find(R.propEq('id', employerId)),
);

export const selectEmployerFromUser = createSelector(
  selectEmployersRef,
  (state) => state.user.employerId,
  (employers, employerId) => employers.find(R.propEq('id', employerId)),
);
